import React from "react";
import { Link } from "react-router-dom";
import {
  Mail,
  Phone,
  MapPin,
  Linkedin,
  Twitter,
  Facebook,
  Github,
  Globe,
  Clock,
  Instagram,
} from "lucide-react";
import { FaLinkedin } from "react-icons/fa";
import {
  COMPANY_INFO,
  SERVICE_BUNDLES,
  INDIVIDUAL_SERVICES,
  AI_SERVICES,
  INDUSTRIES,
  RESOURCES_MENU,
  ABOUT_MENU,
} from "../../data/mock";

const BADGES = [
  {
    href: "https://topfirms.co/companies/software-development/india",
    image:
      "https://topfirms.co/wp-content/uploads/2020/03/software-development-companies-1.jpg",
    alt: "Top Software Development Companies in India - TopFirms",
  },
];

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-10">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <img
              src="/images/itw-logo-black-bg.png"
              alt={COMPANY_INFO.name}
              className="h-12 w-auto mb-6"
            />
            <p className="text-gray-400 mb-6 max-w-md text-sm">
              {COMPANY_INFO.description}
            </p>
            <div className="space-y-3">
              <a
                href={`mailto:${COMPANY_INFO.email}`}
                className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors text-sm"
              >
                <Mail className="h-4 w-4 text-[#b32126]" />
                {COMPANY_INFO.email}
              </a>
              {/* <a
                href={`tel:${COMPANY_INFO.phone}`}
                className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors text-sm"
              >
                <Phone className="h-4 w-4 text-[#b32126]" />
                {COMPANY_INFO.phone}
              </a> */}
              <div className="flex items-start gap-3 text-gray-400 text-sm">
                <MapPin className="h-4 w-4 text-[#b32126] flex-shrink-0 mt-0.5" />
                {COMPANY_INFO.address}
              </div>
              <div className="flex items-start gap-3 text-gray-400 text-sm">
                <Globe className="h-4 w-4 text-[#b32126] flex-shrink-0 mt-0.5" />

                <div className="flex flex-col">
                  <span className="font-bold ">Business Hours</span>
                  <span>Monday - Friday: 10AM - 7PM IST</span>
                </div>
              </div>
            </div>
          </div>

          {/* What We Do */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-5">
              What We Do
            </h3>
            <ul className="space-y-2.5">
              {SERVICE_BUNDLES.slice(0, 4).map((bundle) => (
                <li key={bundle.slug}>
                  <Link
                    to={`/what-we-do/${bundle.slug}`}
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {bundle.title}
                  </Link>
                </li>
              ))}
              <li className="pt-1 border-t border-gray-800 mt-3">
                <Link
                  to="/what-we-do/engagement-model"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Engagement Models
                </Link>
              </li>
              <li>
                <Link
                  to="/what-we-do"
                  className="text-[#b32126] hover:text-[#d42a30] transition-colors text-sm font-medium"
                >
                  View All Services →
                </Link>
              </li>
            </ul>
          </div>

          {/* AI */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-5">AI</h3>
            <ul className="space-y-2.5">
              {AI_SERVICES.slice(0, 4).map((service) => (
                <li key={service.slug}>
                  <Link
                    to={`/ai/${service.slug}`}
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/ai"
                  className="text-[#b32126] hover:text-[#d42a30] transition-colors text-sm font-medium"
                >
                  Explore AI →
                </Link>
              </li>
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-5">
              Industries
            </h3>
            <ul className="space-y-2.5">
              {INDUSTRIES.slice(0, 6).map((industry) => (
                <li key={industry.slug}>
                  <Link
                    to={`/industries/${industry.slug}`}
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {industry.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/industries"
                  className="text-[#b32126] hover:text-[#d42a30] transition-colors text-sm font-medium"
                >
                  View All →
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources & About Us */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-5">Resources</h3>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/resources/case-studies"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Case Studies
                </Link>
              </li>
              <li>
                <Link
                  to="/resources/blogs"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Blogs
                </Link>
              </li>
            </ul>

            <h3 className="text-white font-semibold text-lg mb-5 mt-8">
              About Us
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about/company"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Company
                </Link>
              </li>
              <li>
                <Link
                  to="/about/leadership"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Leadership
                </Link>
              </li>
              <li>
                <Link
                  to="/about/partners"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Partners
                </Link>
              </li>
              <li>
                <Link
                  to="/about/life-at-infotech"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Life @ Infotech.Works
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Partners / Certifications */}
      <div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex items-center justify-center gap-4 sm:gap-6 mb-6">
            <span className="hidden sm:block h-px flex-1 max-w-xs bg-gradient-to-r from-transparent via-gray-700 to-[#b32126]" />
            <h3 className="text-gray-300 text-xs sm:text-sm font-medium uppercase tracking-[0.2em] text-center">
              PARTNERS / CERTIFICATIONS
            </h3>
            <span className="hidden sm:block h-px flex-1 max-w-xs bg-gradient-to-l from-transparent via-gray-700 to-[#b32126]" />
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
            {BADGES.map((badge) => (
              <a
                key={badge.href}
                href={badge.href}
                target="_blank"
                rel="noopener noreferrer"
                className="opacity-80 hover:opacity-100 transition-opacity"
              >
                <img
                  src={badge.image}
                  alt={badge.alt}
                  loading="lazy"
                  className="h-16 sm:h-20 w-auto rounded"
                />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} {COMPANY_INFO.name}. All rights
              reserved.
            </p>
            <div className="flex items-center gap-4">
              <a
                href={COMPANY_INFO.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-white transition-colors"
              >
                <FaLinkedin className="h-5 w-5" />
              </a>
              {/* <a
                href={COMPANY_INFO.social.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-white transition-colors"
              >
                <Twitter className="h-5 w-5" />
              </a> */}
              <a
                href={COMPANY_INFO.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-white transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
              {/* <a
                href={COMPANY_INFO.social.github}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-white transition-colors"
              >
                <Github className="h-5 w-5" />
              </a> */}
            </div>
            <div className="flex items-center gap-6 text-sm text-gray-500">
              <Link
                to="/privacy-notice"
                className="hover:text-white transition-colors"
              >
                Privacy Policy
              </Link>
              <Link to="/terms" className="hover:text-white transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
